// 설정 화면에서 동의를 바꾸면 같은 화면의 '지난 채팅 파일 모으기' 카드가 다시 확인한다.
export const AI_REFERENCE_CONSENT_EVENT = 'wq:ai-reference-consent-changed';

// 자료함 자동 모으기 대상과 같은 문서 형식. 이미지·음성은 모으지 않는다.
export const AI_REFERENCE_DOC_EXTENSIONS = new Set(['hwp', 'hwpx', 'pdf', 'docx', 'xlsx', 'pptx', 'txt']);

// 생기부·상담 대화의 첨부는 서버가 자동으로 모으지 않는다 (services/library_auto_collect.py 와 같은 목록).
export const AUTO_COLLECT_EXCLUDED_CATEGORIES = new Set([
  'record',
  'counseling_care',
  'student_counseling',
  'teacher_care',
]);

/** 이 대화의 문서 첨부를 서버가 자료함에 자동으로 모으는 상태인지. 직접 끈 경우(false)만 꺼진다. */
export const isLibraryAutoCollectOn = (consentPayload, category) => Boolean(
  consentPayload?.feature_enabled
  && consentPayload?.consent?.library_auto_collect?.enabled !== false
  && !AUTO_COLLECT_EXCLUDED_CATEGORIES.has(String(category || ''))
);
